import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Search, MessageCircle, User, Plus, Bell, Calendar } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import ChatSystem from '@/components/ChatSystem';

const BottomNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [unreadCount] = useState(3); // Mock unread count

  const navigationItems = [
    { icon: Home, label: 'Home', path: '/' },
    { icon: Search, label: 'Zoeken', path: '/marketplace' },
    { icon: Calendar, label: 'Afspraken', path: '/afspraken' },
    { icon: MessageCircle, label: 'Chat', action: () => setIsChatOpen(true), badge: unreadCount },
    { icon: User, label: 'Profiel', path: '/profiel' },
  ];

  const handleNavigation = (item: typeof navigationItems[0]) => {
    if (item.action) {
      item.action();
    } else if (item.path) {
      navigate(item.path);
    }
  };

  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-cream-300 z-40">
        <div className="flex items-center justify-around py-2 px-4 max-w-md mx-auto">
          {navigationItems.map((item) => {
            const Icon = item.icon;
            const isActive = item.path === location.pathname;
            return (
              <Button
                key={item.label}
                variant="ghost"
                size="sm"
                onClick={() => handleNavigation(item)}
                className={`flex flex-col items-center gap-1 h-auto py-2 px-3 relative ${
                  isActive 
                    ? 'text-navy-700 bg-cream-100' 
                    : 'text-navy-500 hover:text-navy-700 hover:bg-cream-50'
                }`}
              >
                <Icon className="h-5 w-5" />
                <span className="text-xs font-medium">{item.label}</span>
                {item.badge && item.badge > 0 && (
                  <Badge className="absolute -top-1 -right-1 bg-red-500 text-white text-xs min-w-5 h-5 flex items-center justify-center">
                    {item.badge}
                  </Badge>
                )}
              </Button>
            );
          })}
        </div>
      </div>

      <ChatSystem 
        isOpen={isChatOpen} 
        onClose={() => setIsChatOpen(false)} 
      />
    </>
  );
};

export default BottomNavigation;